export default __webpack_public_path__ + "static/media/howWorkmobile-1.3802e017.jpg";